/**
 * 💝 격려 릴레이 메시지 상수
 * 교육부서 교사들이 서로에게 보낼 수 있는 미리 정의된 격려 메시지
 */

// 격려 메시지 카테고리
export const CHEER_CATEGORIES = {
    gratitude: { id: 'gratitude', name: '감사', emoji: '🙏', icon: '/images/prayer_3d.png', color: 'bg-amber-500' },
    encouragement: { id: 'encouragement', name: '격려', emoji: '💪', icon: '/images/Flexed_biceps.png', color: 'bg-blue-500' },
    blessing: { id: 'blessing', name: '축복', emoji: '✨', icon: '/images/Sparkles.png', color: 'bg-purple-500' },
    comfort: { id: 'comfort', name: '위로', emoji: '🌿', icon: '/images/Seedling.png', color: 'bg-green-500' },
    celebration: { id: 'celebration', name: '축하', emoji: '🎉', icon: '/images/Party_popper.png', color: 'bg-pink-500' },
    prayer: { id: 'prayer', name: '기도', emoji: '🙏', icon: '/images/prayer_3d.png', color: 'bg-indigo-500' },
};

// 격려 메시지 목록
export const CHEER_MESSAGES = [
    // 감사 (gratitude)
    {
        id: 'thanks_today',
        category: 'gratitude',
        message: '오늘도 수고 많으셨어요!',
        emoji: '🙏',
        icon: '/images/prayer_3d.png',
        description: '하루를 마친 동역자에게'
    },
    {
        id: 'thanks_kids',
        category: 'gratitude',
        message: '아이들 잘 돌봐주셔서 감사해요',
        emoji: '💕',
        icon: '/images/Revolving_hearts.png',
        description: '사랑으로 섬기는 교사에게'
    },
    {
        id: 'thanks_prep',
        category: 'gratitude',
        message: '예배 준비해주셔서 감사합니다',
        emoji: '⛪',
        icon: '/images/Church.png',
        description: '예배 준비를 도운 교사에게'
    },
    {
        id: 'thanks_visit',
        category: 'gratitude',
        message: '심방 다녀와주셔서 감사해요',
        emoji: '🏠',
        icon: '/images/House.png',
        description: '심방을 다녀온 교사에게'
    },
    {
        id: 'thanks_prayer',
        category: 'gratitude',
        message: '기도해주셔서 감사합니다',
        emoji: '🙏',
        icon: '/images/prayer_3d.png',
        description: '함께 기도해주는 동역자에게'
    },

    // 격려 (encouragement)
    {
        id: 'encourage_fight',
        category: 'encouragement',
        message: '힘내세요! 응원합니다',
        emoji: '💪',
        icon: '/images/Flexed_biceps.png',
        description: '지친 동역자에게 힘을'
    },
    {
        id: 'encourage_best',
        category: 'encouragement',
        message: '최선을 다하는 모습이 멋져요',
        emoji: '⭐',
        icon: '/images/Glowing_star.png',
        description: '열심히 사역하는 교사에게'
    },
    {
        id: 'encourage_growth',
        category: 'encouragement',
        message: '오늘도 한 뼘 더 성장하셨네요!',
        emoji: '🌱',
        icon: '/images/Seedling.png',
        description: '성장하는 동역자에게'
    },
    {
        id: 'encourage_keep',
        category: 'encouragement',
        message: '포기하지 마세요, 함께 해요',
        emoji: '🤝',
        icon: '/images/Handshake.png',
        description: '어려움을 겪는 교사에게'
    },
    {
        id: 'encourage_trust',
        category: 'encouragement',
        message: '믿고 있어요, 잘하고 계세요',
        emoji: '👍',
        icon: '/images/Thumbs_up.png',
        description: '자신감이 필요한 교사에게'
    },

    // 축복 (blessing)
    {
        id: 'bless_god',
        category: 'blessing',
        message: '주님이 함께하실 거예요',
        emoji: '✨',
        icon: '/images/Sparkles.png',
        description: '믿음의 격려가 필요할 때'
    },
    {
        id: 'bless_day',
        category: 'blessing',
        message: '오늘 하루도 은혜가 넘치길!',
        emoji: '🌈',
        icon: '/images/Glowing_star.png',
        description: '새로운 하루를 시작하는 동역자에게'
    },
    {
        id: 'bless_weekend',
        category: 'blessing',
        message: '이번 주일 은혜로운 예배 되세요',
        emoji: '⛪',
        icon: '/images/Church.png',
        description: '주일을 앞둔 교사에게'
    },
    {
        id: 'bless_family',
        category: 'blessing',
        message: '가정에 평안이 가득하길 기도해요',
        emoji: '🏠',
        icon: '/images/House.png',
        description: '가정을 위한 축복'
    },

    // 위로 (comfort)
    {
        id: 'comfort_rest',
        category: 'comfort',
        message: '쉬어가셔도 괜찮아요',
        emoji: '🌿',
        icon: '/images/Seedling.png',
        description: '지친 동역자에게'
    },
    {
        id: 'comfort_okay',
        category: 'comfort',
        message: '괜찮아요, 다 잘 될 거예요',
        emoji: '🤗',
        icon: '/images/Smiling_face_with_hearts.png',
        description: '걱정하는 교사에게'
    },
    {
        id: 'comfort_notalone',
        category: 'comfort',
        message: '혼자가 아니에요, 함께 있어요',
        emoji: '💝',
        icon: '/images/Growing_heart.png',
        description: '외로울 때'
    },
    {
        id: 'comfort_tears',
        category: 'comfort',
        message: '주님께서 눈물을 닦아주실 거예요',
        emoji: '😢',
        icon: '/images/Crying_face.png',
        description: '힘든 시간을 보내는 동역자에게'
    },

    // 축하 (celebration)
    {
        id: 'celebrate_birthday',
        category: 'celebration',
        message: '생일 축하드려요! 🎂',
        emoji: '🎂',
        icon: '/images/birthday_cake_animated.png',
        description: '생일인 교사에게'
    },
    {
        id: 'celebrate_success',
        category: 'celebration',
        message: '축하해요! 정말 잘하셨어요',
        emoji: '🎉',
        icon: '/images/Party_popper.png',
        description: '좋은 일이 있는 교사에게'
    },
    {
        id: 'celebrate_milestone',
        category: 'celebration',
        message: '사역 1주년 축하해요! 🏆',
        emoji: '🏆',
        icon: '/images/Trophy.png',
        description: '사역 기념일인 교사에게'
    },

    // 기도 (prayer)
    {
        id: 'prayer_today',
        category: 'prayer',
        message: '오늘 하루 기도하고 있어요',
        emoji: '🙏',
        icon: '/images/prayer_3d.png',
        description: '기도로 함께하고 싶을 때'
    },
    {
        id: 'prayer_week',
        category: 'prayer',
        message: '이번 주 함께 기도해요',
        emoji: '📿',
        icon: '/images/prayer_3d.png',
        description: '한 주간 기도 약속'
    },
    {
        id: 'prayer_health',
        category: 'prayer',
        message: '건강을 위해 기도합니다',
        emoji: '💚',
        icon: '/images/Growing_heart.png',
        description: '건강을 챙기고 싶은 동역자에게'
    },
    {
        id: 'prayer_ministry',
        category: 'prayer',
        message: '사역 위에 주님의 인도하심이 있기를',
        emoji: '🕊️',
        icon: '/images/Sparkles.png',
        description: '사역을 위한 기도'
    },
];

// 카테고리별 메시지 필터링
export const getMessagesByCategory = (categoryId) => {
    if (categoryId === 'all') return CHEER_MESSAGES;
    return CHEER_MESSAGES.filter(msg => msg.category === categoryId);
};

// 메시지 ID로 검색
export const getCheerMessageById = (messageId) => {
    return CHEER_MESSAGES.find(msg => msg.id === messageId);
};

// 랜덤 메시지 선택
export const getRandomCheerMessage = (categoryId = null) => {
    const messages = categoryId ? getMessagesByCategory(categoryId) : CHEER_MESSAGES;
    return messages[Math.floor(Math.random() * messages.length)];
};
